import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let IntroduceList = class IntroduceList extends Vue {
};
tslib_1.__decorate([
    Prop()
], IntroduceList.prototype, "introducePic", void 0);
IntroduceList = tslib_1.__decorate([
    Component
], IntroduceList);
export default IntroduceList;
